// FILE: src/components/UploadContent.jsx
import React, { useState } from "react";
import { auth } from "../firebase";
import { uploadContentMeta } from "./content"; // Firestore-only metadata

export default function UploadContent({ onUploaded = () => {} }) {
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [url, setUrl] = useState("");
  const [type, setType] = useState("video"); // "video" or "document"
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  const resetForm = () => {
    setTitle("");
    setDescription("");
    setUrl("");
    setType("video");
    setSaving(false);
    setError("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!title.trim()) {
      setError("Title is required.");
      return;
    }
    if (!url.trim()) {
      setError("URL is required.");
      return;
    }

    const user = auth.currentUser;
    if (!user) {
      setError("You must be signed in as admin to add content.");
      return;
    }

    setSaving(true);

    try {
      const meta = {
        title: title.trim(),
        description: description.trim() || null,
        fileUrl: url.trim(),     // treat this as the file/video URL
        storagePath: null,       // no Firebase Storage
        mimeType: null,
        size: null,
        type,                    // "video" or "document"
      };

      await uploadContentMeta(meta);

      resetForm();
      onUploaded();
      alert("Content saved.");
    } catch (err) {
      console.error("UploadContent save error:", err);
      setError("Failed to save content: " + (err.message || String(err)));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="p-4 bg-white rounded shadow-sm max-w-2xl mx-auto">
      <h3 className="text-lg font-semibold mb-3">
        Add Content (link to video or document)
      </h3>

      <form onSubmit={handleSubmit} className="space-y-3">
        <div>
          <label className="block text-sm font-medium mb-1">Title</label>
          <input
            type="text"
            placeholder="Title (required)"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            className="w-full p-2 border rounded"
          />
        </div>

        <div>
          <label className="block text-sm font-medium mb-1">
            Description (optional)
          </label>
          <textarea
            placeholder="Short description..."
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            className="w-full p-2 border rounded"
          />
        </div>

        <div>
          <label className="block text-sm font-medium mb-1">
            Content URL (YouTube / Google Drive / PDF / DOCX)
          </label>
          <input
            type="url"
            placeholder="https://..."
            value={url}
            onChange={(e) => setUrl(e.target.value)}
            className="w-full p-2 border rounded"
          />
          <p className="text-xs text-gray-500 mt-1">
            Example: YouTube video link, Google Drive share link, or direct PDF/DOCX URL.
          </p>
        </div>

        <div>
          <label className="block text-sm font-medium mb-1">
            Content type
          </label>
          <select
            value={type}
            onChange={(e) => setType(e.target.value)}
            className="w-full p-2 border rounded"
          >
            <option value="video">Video</option>
            <option value="document">Document</option>
          </select>
        </div>

        {error && (
          <div className="text-sm text-red-600 mt-1">{error}</div>
        )}

        <div className="flex gap-2 mt-2">
          <button
            type="submit"
            disabled={saving}
            className="px-4 py-2 bg-indigo-600 text-white rounded disabled:opacity-50"
          >
            {saving ? "Saving…" : "Save"}
          </button>

          <button
            type="button"
            onClick={resetForm}
            disabled={saving}
            className="px-4 py-2 border rounded"
          >
            Reset
          </button>
        </div>
      </form>
    </div>
  );
}
